import mobileTracker from './mobile';
import registrationPageTracker from './registration-page';

export default {
  ...mobileTracker,
  ...registrationPageTracker,
};
